import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getSmartListCount = createAsyncThunk(
  "agentListData/getSmartListCount",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/recruitment/smartlist-count`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data.updatedSmartlistCount;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

export const getAgentRecruitmentSmartList = createAsyncThunk(
  "agentListData/getAgentRecruitmentSmartList",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/smartlists?type=agent`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: { all: "true" },
        }
      );
      if (resp.data.smartlists?.length > 0) {
        thunkAPI.dispatch(
          getSmartListCount({
            smartListIds: resp.data.smartlists?.map((list) => list.id),
          })
        );
      }
      return resp.data.smartlists;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
